import { Flex, Text } from "@chakra-ui/react";

export interface CertificationItemProps {
    image: string;
    certIdentifier: string;
};

const CertificationItem = (props: CertificationItemProps) => {
    return (
        <Flex 
            flexDirection='column'
            padding='10px'
        >
            <Flex 
                bgImage={ props.image }
                bgPosition='center'
                bgSize='contain'
                bgRepeat='no-repeat'
                height='150px'
                width='300px'>
            </Flex>
            <Flex 
                width='300px'
                paddingLeft='150px'
                paddingTop='5px'>
                <Text 
                    fontSize='smaller'
                    fontWeight='bold'
                    color='brand.white'
                >
                    { props.certIdentifier }
                </Text>
            </Flex>
        </Flex>
    );
};

export default CertificationItem;